export default __webpack_public_path__ + "static/media/exam.6fe7e14b.svg";